import { ReactNode } from 'react';

import * as Styled from './multiple-choice-radio.style';
import {
  MultipleChoiceListCorrect,
  MultipleChoiceListIncorrect,
} from '../multiple-choice';

type Props = {
  label: ReactNode;
  showAnswer?: boolean;
  isCorrect?: boolean;
};

const MultipleChoicePrintRadio = ({ label, showAnswer, isCorrect }: Props) => (
  <Styled.MultipleChoiceRadioInputLabel>
    <Styled.MultipleChoiceRadioInputFieldWrapper>
      {showAnswer && isCorrect ? (
        <MultipleChoiceListCorrect isRevealAnswer={false} />
      ) : showAnswer && !isCorrect ? (
        <MultipleChoiceListIncorrect isRevealAnswer={false} />
      ) : (
        <Styled.MultipleChoiceRadioInputDecor>
          <div />
        </Styled.MultipleChoiceRadioInputDecor>
      )}
    </Styled.MultipleChoiceRadioInputFieldWrapper>
    <Styled.MultipleChoiceRadioInputTextWrapper>
      {label}
    </Styled.MultipleChoiceRadioInputTextWrapper>
  </Styled.MultipleChoiceRadioInputLabel>
);

export default MultipleChoicePrintRadio;
